import React, { useRef, useState } from "react";
import { api } from "../api/client";
import styles from "./ImageUpload.module.scss";

type Props = {
    value: string | null | undefined;
    onChange: (url: string | null) => void;
    uploadPath?: string;          // эндпоинт загрузки, по умолчанию /api/uploads
    fieldName?: string;           // имя поля файла, по умолчанию "file"
    label?: string;
};

const ImageUpload: React.FC<Props> = ({
                                          value,
                                          onChange,
                                          uploadPath = "/api/uploads",
                                          fieldName = "file",
                                          label = "Изображение",
                                      }) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState<string | null>(null);

    const pick = () => inputRef.current?.click();

    const onFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;
        setErr(null);
        setBusy(true);
        try {
            const resp = await api.upload<any>(uploadPath, file, fieldName);
            // ожидаем, что бэк вернёт { url: 'https://...' } или { path: '...' }
            const url = resp?.url || resp?.path || null;
            if (!url) throw new Error("Сервер не вернул ссылку на файл");
            onChange(url);
        } catch (e: any) {
            setErr(e?.message || "Не удалось загрузить файл");
        } finally {
            setBusy(false);
            if (inputRef.current) inputRef.current.value = "";
        }
    };

    const clear = () => onChange(null);

    return (
        <div className={styles.wrap}>
            <div className={styles.labelRow}>
                <label className={styles.label}>{label}</label>
                {value && <button type="button" className={styles.linkBtn} onClick={clear}>Очистить</button>}
            </div>

            <div className={styles.box}>
                {value ? (
                    <div className={styles.preview} onClick={pick} title="Заменить изображение">
                        <img src={value} alt="preview" />
                    </div>
                ) : (
                    <div className={styles.placeholder} onClick={pick}>
                        <div>Загрузить изображение</div>
                        <div className={styles.hint}>PNG/JPG, до 10 МБ</div>
                    </div>
                )}
                <input
                    ref={inputRef}
                    type="file"
                    accept="image/*"
                    onChange={onFile}
                    style={{ display: "none" }}
                />
            </div>

            <div className={styles.actions}>
                <button type="button" className={styles.btn} onClick={pick} disabled={busy}>
                    {busy ? "Загрузка…" : (value ? "Заменить" : "Выбрать файл")}
                </button>
                {value && (
                    <a href={value} className={styles.btnGhost} target="_blank" rel="noreferrer">Открыть</a>
                )}
            </div>

            {err && <div className={styles.err}>{err}</div>}
        </div>
    );
};

export default ImageUpload;
